(function () {
  'use strict';

  function initProduct(section) {
    if (section.dataset.fcProductMobileReady === 'true') return;
    section.dataset.fcProductMobileReady = 'true';

    var slideshow = section.querySelector('[data-product-photos]');
    var counter = section.querySelector('[data-fc-gallery-count]');
    if (slideshow && counter) {
      var scheduled = false;
      var updateCounter = function () {
        scheduled = false;
        var slides = Array.prototype.slice.call(slideshow.querySelectorAll('.flickity-slider > .product-main-slide'));
        if (!slides.length) slides = Array.prototype.slice.call(slideshow.querySelectorAll('.product-main-slide'));
        if (!slides.length) return;
        var current = slides.findIndex(function (slide) { return slide.classList.contains('is-selected'); });
        var position = current < 0 ? 1 : current + 1;
        counter.textContent = position + '/' + slides.length;
        counter.setAttribute('aria-label', 'Image ' + position + ' of ' + slides.length);
      };
      var scheduleCounter = function () {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(updateCounter);
      };
      new MutationObserver(scheduleCounter).observe(slideshow, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        subtree: true
      });
      scheduleCounter();
    }

    var shareButton = section.querySelector('[data-fc-product-share]');
    var shareStatus = section.querySelector('[data-fc-share-status]');
    if (shareButton) {
      shareButton.addEventListener('click', async function () {
        var shareData = { title: section.dataset.productTitle, url: window.location.href };
        try {
          if (navigator.share) {
            await navigator.share(shareData);
          } else if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(shareData.url);
            if (shareStatus) shareStatus.textContent = 'Product link copied';
          } else if (shareStatus) {
            shareStatus.textContent = 'Use your browser to copy this page link';
          }
        } catch (error) {
          if (error.name !== 'AbortError' && shareStatus) shareStatus.textContent = 'Unable to share this link';
        }
      });
    }
  }

  function initAll(root) {
    if (root.matches && root.matches('.fc-product-mobile')) initProduct(root);
    root.querySelectorAll('.fc-product-mobile').forEach(initProduct);
  }

  initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
}());
